<template>  
    <div @dblclick="toggleEditable">
        <div v-if="isEditable">
            <select name="" id="" class="border border-dark-primary rounded p-1" @change="updateFeedback"  :value="company.current_client_feedback ?? ''">
                <option value="">------</option>
                <option value="approved">Approved</option>
                <option value="excluded">Excluded</option>
                <option value="hold">Hold</option>
                <option value="pass">Pass</option>
                <option value="research_further">Research Further</option>
            </select>
        </div>
        <div v-else>
            <span>{{ clientFeedback }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "client-feedback-cell"
    }
</script>

<script setup>
import { defineProps, computed, defineEmits, ref } from 'vue';
import { useStore } from 'vuex';
import { createCompanyClientFeedback, clientFeedbackErrorMessage } from '@/services/Company';
import { useToast } from 'vue-toast-notification';

    const store = useStore()
    const $toast = useToast()

    const isEditable = ref(false)

    const props = defineProps({
        company: Object
    })

    const emit = defineEmits(['refetch-companies'])

    function toggleEditable(){
        // Feedback is recorded against the company's campaign, so there is nothing to edit without one.
        if(!props.company.campaign) {
            return
        }
        isEditable.value = !isEditable.value
    }

    const clientFeedback = computed(() => {
        // The latest feedback recorded for the company's current client
        return props.company.current_client_feedback ? props.company.current_client_feedback : "--"
    })

    async function updateFeedback(e) {
        const token = store.state.auth.token
        const result = await createCompanyClientFeedback(props.company.id, e.target.value, token)
        if(result.status != 201) {
            $toast.open({ type: 'error', duration: 10000, message: clientFeedbackErrorMessage(result) })
            return
        }
        emit('refetch-companies')
        isEditable.value = false
    }

</script>